import { StyleSheet } from 'react-native'
import { ThemedText, ThemedView } from '@app/theme'

const PageNotFound = () => {
  return (
    <ThemedView flex={1} justifyContent='center' alignItems='center'>
      <ThemedText variant='h4s'>404 Error</ThemedText>
      <ThemedText variant='b3r'>Sorry, this page is not available</ThemedText>
    </ThemedView>
  )
}

export default PageNotFound

const styles = StyleSheet.create({})